/* jshint esversion: 6 */
/* jshint ignore:start */
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const Success = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        sessionStorage.setItem("Paymentstatus", "PaymentDone");
        const pages = secureLocalStorage.getItem("pages");
        navigate(`/${pages}`);
    }, [location]);

    return null;
};

export default Success;

export const Cancel = () => {

    const navigate = useNavigate();

    useEffect(() => {
        sessionStorage.setItem("Paymentstatus", "Paymentfaild");
        const pages = secureLocalStorage.getItem("pages");
        navigate(`/${pages}`);
    }, []);

    return null;
};
/* jshint ignore:end */